var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdlCustPointer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21495_196278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0015 0C7.49916 0 3.84863 3.626 3.84863 8.09904C3.84863 10.3873 6.09333 14.487 6.09333 14.487L11.701 24L17.5519 14.598C17.5519 14.598 20.151 10.6865 20.151 8.09904C20.1517 3.626 16.5018 0 12.0015 0ZM11.9633 12.5598C9.38474 12.5598 7.29609 10.4712 7.29609 7.88983C7.29609 5.31191 9.38405 3.22462 11.9633 3.22462C14.5406 3.22462 16.6313 5.31191 16.6313 7.88983C16.6313 10.4712 14.5406 12.5598 11.9633 12.5598Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21495_196278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdlCustPointer);
export default __webpack_public_path__ + "static/media/IDL_Cust_Pointer.a1172b399e27a2a6c69ad25cdedecbe4.svg";
export { ForwardRef as ReactComponent };